import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import freeze from 'redux-freeze';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from './ducks';

const configureStore = preloadedState => {
	const middlewares = [thunk, freeze];

	if (process.env.NODE_ENV !== 'production') {
		const logger = createLogger();

		middlewares.push(logger);

		const middlewareEnhancer = applyMiddleware(...middlewares);

		const enhancers = [middlewareEnhancer];

		const composedEnhancers = composeWithDevTools(...enhancers);

		return createStore(rootReducer, preloadedState, composedEnhancers);
	}

	const middlewareEnhancer = applyMiddleware(...middlewares);

	return createStore(rootReducer, preloadedState, middlewareEnhancer);
};

const store = configureStore();

export default store;
